<template>
  <div class="dropdown">
    <button
      class="btn btn-outline-secondary dropdown-toggle"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      {{ copy.title }}
    </button>
    <div class="dropdown-menu dropdown-menu-right">
      <a
        v-for="option in options"
        :key="option.value"
        class="dropdown-item"
        :class="{ 'active': option.value === selected, 'disabled': option.value === selected }"
        href="#"
        @click.prevent="handleSortClick(option.value)"
      >
        {{ option.label }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['options', 'selected', 'copy'],

  methods: {
    handleSortClick(value) {
      if (value !== this.selected) {
        this.$emit('sort-change', value);
      }
    }
  }
};
</script>

<style scoped>
.dropdown-item.active {
  background-color: #007bff;
  color: white;
}

.dropdown-item.disabled {
  pointer-events: none;
  opacity: 0.65;
}
</style>
